import { gql, useQuery } from "@apollo/client";
import Session from "@lib/session";
import { useContext, useEffect, useRef } from "react";
import { debugContext } from "@hudson/ui/lib";
import FrameConfig from "@lib/classes/FrameConfig";
import { QueryContentArgs, TokenContent } from "@graphql/api";

const query = (fields: (keyof TokenContent)[]) => gql`
query content($serviceAreaId: Int, $showToken: Boolean, $tokenGroup: String!) {
  ${contentSchema(fields)}
}
`;

const variables = (
  showToken?: boolean,
  defaults: { serviceArea?: number } = {},
): QueryContentArgs => {
  return {
    serviceAreaId: defaults.serviceArea || Session.getBooking().serviceArea,
    showToken,
    tokenGroup: new FrameConfig().tokenGroup || "",
  };
};

export const contentSchema = (fields: (keyof TokenContent)[]) => `
  content(serviceAreaId: $serviceAreaId, showToken: $showToken, tokenGroup: $tokenGroup) {
    id
    ${fields.join("\n")}
  }
`;

interface ContentQuery<T extends keyof TokenContent> {
  __typename?: "Query";
  content?: (Pick<TokenContent, "id"> & Pick<TokenContent, T>) | null;
}

export async function getContent<T extends (keyof TokenContent)[]>(
  fields: T = [] as unknown as T,
  serviceArea?: number,
) {
  type Fields = T[number];
  return await global.window.apolloClient.query<ContentQuery<Fields>, QueryContentArgs>({
    query: query(fields),
    variables: variables(window.debugContent, { serviceArea }),
  });
}

function useContent<T extends (keyof TokenContent)[]>(fields: T = [] as unknown as T) {
  const { debugMode } = useContext(debugContext);

  const queryVars: QueryContentArgs = variables(debugMode);

  type Fields = T[number];
  return useQuery<ContentQuery<Fields>, QueryContentArgs>(query(fields), { variables: queryVars });
}

export default useContent;
